module.exports = __webpack_public_path__ + "static/media/fileIcon.168c22a7.svg";